import { createFileRoute } from "@tanstack/react-router";
import { optionalLiteralParam, parseableSearchSchema } from "@crm/effect/schema/search";
import { Schema } from "effect";

const frtSearchSchema = parseableSearchSchema(
  Schema.Struct({
    level: optionalLiteralParam("all", "excellent", "good", "acceptable", "slow"),
    exclusion: optionalLiteralParam("all", "none", "pending", "approved", "rejected"),
  }),
);

export const Route = createFileRoute("/_protected/dashboard/metrics/_details/frt/")({
  validateSearch: frtSearchSchema,
  pendingMinMs: 200
});
